import React, { useEffect, useState } from "react";

import {
  Version,
  checkIsPublishedByFileUpload,
} from "../../../../../domain/Version";
import { DialogPhaseStatesType, useDialog } from "../../../helpers/hooks";

import { Input } from "@fluentui/react-components";

import {
  createDefaultVersionTitle,
  validateNewVersionTitle,
} from "@/helpers/versionTitle";
import { translation } from "@/i18n";
import { nsVersion } from "@/i18n/locales/version";
import styles from "./index.module.css";

const useTranslation = translation.use(nsVersion);

export const DialogVersionDuplicate: React.FC<
  {
    versions: Version[];
    allVersions: Version[];
    selectedVersionIds: string[];
    setSelectedVersionIds: React.Dispatch<React.SetStateAction<string[]>>;
    handleDuplicateVersions: (
      targetVersionIds?: string[],
      options?: {
        titleMap?: Map<string, string>;
      }
    ) => Promise<void>;
  } & DialogPhaseStatesType
> = ({
  versions,
  allVersions,
  selectedVersionIds,
  setSelectedVersionIds,
  dialogPhase,
  setDialogPhase,
  handleDuplicateVersions,
}) => {
  const { t } = useTranslation();
  const { renderDialogs } = useDialog({
    dialogPhase,
    setDialogPhase,
  });

  const versionId = selectedVersionIds[0];
  const version = versions.find(({ id }) => id === versionId);

  const [newVersionTitle, setNewVersionTitle] = useState("");

  useEffect(() => {
    setNewVersionTitle(
      createDefaultVersionTitle({
        title: version?.title ?? "",
        versions: allVersions,
        category: version?.category ?? "",
      })
    );
  }, [version, allVersions]);

  const runDuplicate = async () => {
    // NOTE: 簡易最適化は複製しない
    if (version && !checkIsPublishedByFileUpload(version)) {
      setDialogPhase(null);
      const titleMap = new Map<string, string>();
      titleMap.set(version.id, newVersionTitle);
      await handleDuplicateVersions([version.id], { titleMap });
    }
  };

  const validateNewVersionTitleResult = validateNewVersionTitle(
    newVersionTitle,
    allVersions,
    version?.category ?? ""
  );

  return (
    <>
      {renderDialogs({
        confirm: {
          title: t.version.duplicate.dialog.title(),
          displayMessage: t.version.duplicate.dialog.message({
            versionName: version?.title || t.version.fallbackName(),
          }),
          buttonText: t.version.duplicate.dialog.button(),
          onClick: runDuplicate,
          onClickCancel: () => {
            setNewVersionTitle("");
            setSelectedVersionIds([]);
          },
          element: (
            <div>
              <Input
                hidden={!selectedVersionIds.length}
                className={styles.versionTitleInput}
                value={newVersionTitle}
                onChange={(e) => setNewVersionTitle(e.target.value)}
              />
              {!!validateNewVersionTitleResult.message && (
                <div className={styles.warningMessage}>
                  {validateNewVersionTitleResult.message}
                </div>
              )}
            </div>
          ),
          isDisableButton: !validateNewVersionTitleResult.valid,
        },
      })}
    </>
  );
};
